import { useState, useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const usePagination = () => {
  
  const navigate = useNavigate();
  const location = useLocation();

  // Initialize pagination state from router or default values
  const initialPage = location.state?.page || 0;
  const initialRowsPerPage = location.state?.rowsPerPage || 10;

  const [page, setPage] = useState(initialPage);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage );
  const [totalData, setTotalData] = useState(0);

  const handleChangePage = useCallback((event, newPage) => {
    setPage(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }, []);

  useEffect(() => {
    navigate(location.pathname, {
      state: {
        ...location.state,
        page: page,
        rowsPerPage: rowsPerPage,
      },
      replace: true,
    });
  }, [page,rowsPerPage]);

  const paginateProps = {
    page,
    rowsPerPage,
    totalData,
    handleChangePage,
    handleChangeRowsPerPage,
    setPage,
    setRowsPerPage,
    setTotalData,
  };

  return paginateProps;
};